import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useKubernetesObjectManifestInspection() {
    return useBooleanFlagValue("kubernetes-object-manifest-inspection", false);
}
